import { Injectable, inject } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { UploadKeydocumentDialogComponent } from "./upload-keydocument-dialog.component";

@Injectable()
export class UploadKeydocumentDialogService {
  dialog = inject(MatDialog);

  public open(): Observable<any> {
    const config = new MatDialogConfig();
    config.panelClass = ["cg-dialog", "middle"];
    config.backdropClass = "cg-dialog-backdrop";
    config.disableClose = true;
    config.data = {};
    const dialogRef = this.dialog.open(UploadKeydocumentDialogComponent, config);
    return dialogRef.afterClosed();
  }
}
